import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { PaymentCollection } from "../../../Constant";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../Dashboard/Default/DashboardStatCard.scss";

const SaleDetails = (props) => {
    const authState = useSelector((state) => state.auth);
    const value = props.details || {};

    const SalesData = [
        {
            id: 1,
            title: 'Today',
            link: `${process.env.PUBLIC_URL}/report/payment-collection?day=today`,
            counter: value.today,
            tone: 'primary',
            icon: 'icofont icofont-money',
        },
        {
            id: 2,
            title: 'This Month',
            link: `${process.env.PUBLIC_URL}/report/payment-collection?day=this_month`,
            counter: value.this_month,
            tone: 'secondary',
            icon: 'icofont icofont-calendar',
        },
        {
            id: 3,
            title: 'Total Dues',
            link: `${process.env.PUBLIC_URL}/report/payment-due`,
            counter: value.dues,
            tone: 'warning',
            icon: 'icofont icofont-warning-alt',
        },
        {
            id: 4,
            title: 'Wallet',
            link: `${process.env.PUBLIC_URL}/customers/wallet`,
            counter: value.wallet_amount,
            tone: 'success',
            icon: 'icofont icofont-wallet',
        },
    ]

    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="dash-stats">
                    <CardHeader className="pb-0">
                        <H3>{PaymentCollection}</H3>
                    </CardHeader>

                    <CardBody>
                        <div className="dash-stats__grid">
                            {SalesData.map((data) => {
                                const amount = data.counter ?? '0';
                                return (
                                    <Link
                                        key={data.id}
                                        to={data.link}
                                        className={`dash-stat dash-stat--${data.tone}`}
                                        aria-label={`${data.title}: ${authState.currency || ''} ${amount}`}
                                    >
                                        <div className="dash-stat__main">
                                            <span className="dash-stat__icon" aria-hidden="true">
                                                <i className={data.icon}></i>
                                            </span>
                                            <div className="dash-stat__body">
                                                <span className="dash-stat__label">{data.title}</span>
                                                <span className="dash-stat__value" title={`${authState.currency || ''} ${amount}`}>
                                                    {authState.currency && (
                                                        <span className="dash-stat__currency">{authState.currency}</span>
                                                    )}
                                                    {amount}
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default SaleDetails;
